import fetch from 'cross-fetch'

export function postFormData(url, body = {}) {
  const headers = {
    Authorization: process.env.REACT_APP_TOKEN,
  }
  const formData = new FormData()

  for (const key in body) {
    // eslint-disable-next-line no-prototype-builtins
    if (key in body) {
      formData.append(key, body[key])
    }
  }

  return fetch(url, { method: 'post', headers, body: formData })
}

export function post(url, body = {}, hasHeaders = true) {
  const headers = hasHeaders ? { Authorization: process.env.REACT_APP_TOKEN, 'Content-Type': 'application/json' } : null
  return fetch(url, { method: 'post', headers, body: JSON.stringify(body.data) })
}
